"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var button_1 = require("@kaizen/button");
var close_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/close.icon.svg"));
var GenericModalSection_1 = __importDefault(require("./GenericModalSection"));
var ModalHeader_module_scss_1 = __importDefault(require("./ModalHeader.module.scss"));
var ModalHeader = /** @class */ (function (_super) {
    __extends(ModalHeader, _super);
    function ModalHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalHeader.prototype.render = function () {
        var _a = this.props, reversed = _a.reversed, onDismiss = _a.onDismiss, children = _a.children;
        return (react_1["default"].createElement(GenericModalSection_1["default"], null,
            react_1["default"].createElement("div", { className: ModalHeader_module_scss_1["default"].dismissButton },
                react_1["default"].createElement(button_1.IconButton, { label: "Dismiss", icon: close_icon_svg_1["default"], reversed: reversed, onClick: onDismiss, disabled: onDismiss == undefined })),
            children));
    };
    return ModalHeader;
}(react_1["default"].Component));
exports["default"] = ModalHeader;
//# sourceMappingURL=ModalHeader.js.map